module.exports = "pegasus_template/assets/header-fall-pets-3.jpg";